module.exports = __webpack_public_path__ + "static/media/contactBcg.60e48383.jpeg";